import styled from "styled-components";

export const NoMatchContainer = styled.div`
  text-align: center;
`;
